<template>
  <div class="min-h-screen bg-gradient-to-br from-purple-50 via-white to-blue-50 flex items-center justify-center px-4">
    <div class="max-w-lg w-full">
      <div class="bg-white rounded-3xl shadow-2xl p-8 text-center border border-purple-100">
        <div class="mb-8">
          <div class="relative inline-block">
            <div class="text-8xl font-black text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-blue-600 mb-4">
              404
            </div>
            <div class="absolute -top-2 -right-2">
              <div class="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center animate-bounce">
                <svg class="w-4 h-4 text-yellow-800" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                </svg>
              </div>
            </div>
          </div>

          <h1 class="text-2xl font-bold text-gray-800 mb-2">Página Não Encontrada</h1>
          <div class="w-20 h-1 bg-gradient-to-r from-purple-500 to-blue-500 mx-auto rounded-full"></div>
        </div>

        <div class="mb-8">
          <div class="inline-flex items-center justify-center w-24 h-24 bg-purple-100 rounded-full mb-6">
            <svg class="w-12 h-12 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>

          <p class="text-gray-600 text-lg leading-relaxed mb-2">
            A página que procura não existe ou foi removida.
          </p>
          <p class="text-gray-500 text-sm">
            Verifique o endereço ou navegue para uma página válida.
          </p>
        </div>

        <div class="space-y-3">
          <router-link
            :to="dashboardRoute"
            class="block w-full bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white font-semibold py-3 px-6 rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-lg"
          >
            <span class="flex items-center justify-center">
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
              Ir para o Dashboard
            </span>
          </router-link>

          <button
            @click="goBack"
            class="block w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-3 px-6 rounded-xl transition-all duration-300"
          >
            <span class="flex items-center justify-center">
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              Voltar à Página Anterior
            </span>
          </button>

          
        </div>
      </div>

      <div class="text-center mt-6">
        <p class="text-gray-500 text-sm">
          Sistema de Gestão de Segurança • Erro 404
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundView',
  computed: {
    dashboardRoute() {
      // Check if user is logged in and get user data
      try {
        const userData = JSON.parse(localStorage.getItem('user'));
        const userType = userData?.tipo?.nome;

        // If user is a technician, redirect to tecnico dashboard
        if (userType === 'tecnico') {
          return '/tecnico/dashboard';
        }

        // For all other users, redirect to main dashboard
        return '/dashboard';
      } catch (error) {
        // If there's an error parsing user data, default to main dashboard
        console.warn('Error parsing user data:', error);
        return '/dashboard';
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>